// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { multipart, post } from '../../../../common/api'
import { ADD_TASK, ASSIGNED_PROJECT_LIST, DELETE_TASK, EDIT_TASK, GET_TASK, HOLD_TASK, TASK, TASK_STATUS_LIST, GET_TASK_DETAIL, TASK_STATUS_CHANGE } from '../../../../common/constant'

export const actionAddTask = createAsyncThunk('appTask/actionAddTask', async (params, thunkAPI) => {
    return await multipart(ADD_TASK, params, thunkAPI)
})

export const actionTask = createAsyncThunk('appTask/actionTask', async (params, thunkAPI) => {
    return await post(TASK, params, thunkAPI)
})

export const actionDeleteTask = createAsyncThunk('appTask/actionDeleteTask', async (params, thunkAPI) => {
    return await post(DELETE_TASK, params, thunkAPI)
})

export const actionHoldTask = createAsyncThunk('appTask/actionHoldTask', async (params, thunkAPI) => {
    return await post(HOLD_TASK, params, thunkAPI)
})

export const actionEditTask = createAsyncThunk('appTask/actionEditTask', async (params, thunkAPI) => {
    return await multipart(EDIT_TASK, params, thunkAPI)
})

export const actionGetTask = createAsyncThunk('appTask/actionGetTask', async (params, thunkAPI) => {
    return await post(GET_TASK, params, thunkAPI)
})

export const actionAssignedProject = createAsyncThunk('appTask/actionAssignedProject', async (params, thunkAPI) => {
    return await post(ASSIGNED_PROJECT_LIST, params, thunkAPI)
})

export const actionTaskStatus = createAsyncThunk('appTask/actionTaskStatus', async (params, thunkAPI) => {
    return await post(TASK_STATUS_LIST, params, thunkAPI)
})

export const actionGetTaskDetail = createAsyncThunk('appTask/actionGetTaskDetail', async (params, thunkAPI) => {
    return await post(GET_TASK_DETAIL, params, thunkAPI)
})

export const actionChangeStatusTask = createAsyncThunk('appTask/actionChangeStatusTask', async (params, thunkAPI) => {
    return await post(TASK_STATUS_CHANGE, params, thunkAPI)
})

export const appTaskSlice = createSlice({
    name: 'appTask',
    initialState: {
        //add
        loadingAdd: false,
        addTask: null,

        //delete
        loadingDelete: false,
        deleteTask: null,

        //hold
        loadingHold: false,
        holdTask: null,

        //list
        loading: false,
        task: null,

        //edit
        loadingEdit: false,
        editTask: null,

        //get
        loadingGet: false,
        getTask: null,

        //assigned-project-list
        loadingAssignedProject: false,
        assignedProject: null,

        //taskStatus
        loadingTaskStatus: false,
        taskStatus: null,

        //taskDetail
        loadingGetDetail: false,
        getTaskDetail: null,

        //task change status
        loadingChangeStatus: false,
        changeStatusTask: null

    },
    reducers: {
        resetAddTaskResponse: (state) => {
            state.addTask = null
        },
        resetDeleteTaskResponse: (state) => {
            state.deleteTask = null
        },
        resetHoldTaskResponse: (state) => {
            state.holdTask = null
        },
        resetTaskResponse: (state) => {
            state.task = null
        },
        resetEditTaskResponse: (state) => {
            state.editTask = null
        },
        resetGetTaskResponse: (state) => {
            state.getTask = null
        },
        resetAssignedProjectResponse: (state) => {
            state.getTask = null
        },
        resetTaskStatusResponse: (state) => {
            state.taskStatus = null
        },
        resetGetTaskDetailResponse: (state) => {
            state.getTaskDetail = null
        },
        resetChangeStatusTaskResponse: (state) => {
            state.changeStatusTask = null
        }
    },
    extraReducers: builder => {
        builder
            //add
            .addCase(actionAddTask.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddTask.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addTask = action.payload
            })
            .addCase(actionAddTask.rejected, (state) => {
                state.loadingAdd = false
            })

            //delete
            .addCase(actionDeleteTask.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteTask.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteTask = action.payload
            })
            .addCase(actionDeleteTask.rejected, (state) => {
                state.loadingDelete = false
            })

            //hold
            .addCase(actionHoldTask.pending, (state) => {
                state.loadingHold = true
            })
            .addCase(actionHoldTask.fulfilled, (state, action) => {
                state.loadingHold = false
                state.holdTask = action.payload
            })
            .addCase(actionHoldTask.rejected, (state) => {
                state.loadingHold = false
            })


            //list
            .addCase(actionTask.pending, (state) => {
                state.loading = true
            })
            .addCase(actionTask.fulfilled, (state, action) => {
                state.loading = false
                state.task = action.payload
            })
            .addCase(actionTask.rejected, (state) => {
                state.loading = false
            })

            //edit
            .addCase(actionEditTask.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditTask.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editTask = action.payload
            })
            .addCase(actionEditTask.rejected, (state) => {
                state.loadingEdit = false
            })

            //get
            .addCase(actionGetTask.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetTask.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getTask = action.payload
            })
            .addCase(actionGetTask.rejected, (state) => {
                state.loadingGet = false
            })

            //assigned-project-list
            .addCase(actionAssignedProject.pending, (state) => {
                state.loadingAssignedProject = true
            })
            .addCase(actionAssignedProject.fulfilled, (state, action) => {
                state.loadingAssignedProject = false
                state.assignedProject = action.payload
            })
            .addCase(actionAssignedProject.rejected, (state) => {
                state.loadingAssignedProject = false
            })

            //taskStatus
            .addCase(actionTaskStatus.pending, (state) => {
                state.loadingTaskStatus = true
            })
            .addCase(actionTaskStatus.fulfilled, (state, action) => {
                state.loadingTaskStatus = false
                state.taskStatus = action.payload
            })
            .addCase(actionTaskStatus.rejected, (state) => {
                state.loadingTaskStatus = false
            })

            //getTaskDetail
            .addCase(actionGetTaskDetail.pending, (state) => {
                state.loadingGetDetail = true
            })
            .addCase(actionGetTaskDetail.fulfilled, (state, action) => {
                state.loadingGetDetail = false
                state.getTaskDetail = action.payload
            })
            .addCase(actionGetTaskDetail.rejected, (state) => {
                state.loadingGetDetail = false
            })

            //change status
            .addCase(actionChangeStatusTask.pending, (state) => {
                state.loadingChangeStatus = true
            })
            .addCase(actionChangeStatusTask.fulfilled, (state, action) => {
                state.loadingChangeStatus = false
                state.changeStatusTask = action.payload
            })
            .addCase(actionChangeStatusTask.rejected, (state) => {
                state.loadingChangeStatus = false
            })

    }
})
export const { resetAddTaskResponse, resetTaskResponse, resetDeleteTaskResponse, resetHoldTaskResponse, resetEditTaskResponse, resetGetTaskResponse, resetAssignedProjectResponse, resetTaskStatusResponse, resetGetTaskDetailResponse, resetChangeStatusTaskResponse } = appTaskSlice.actions

export default appTaskSlice.reducer